module.exports = __webpack_public_path__ + "assets/img/sidebar_setting_active.dd07ef6c.svg";